var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _text, _g11, _g12, _font, _text2, _font2, _text3, _font3, _text4, _font4, _text5, _font5, _text6, _font6, _text7, _font7, _text8, _font8, _text9, _font9, _text10, _font10, _text11, _font11, _text12, _g13, _text13, _g14, _g15, _g16, _text14, _font12, _text15, _font13, _text16, _g17, _text17, _font14, _text18, _font15, _text19, _font16, _text20, _font17, _text21, _g18, _g19, _text22, _text23, _text24, _g20, _b, _text25, _g21, _font18, _text26, _font19, _text27, _font20, _text28, _g22, _b2, _text29, _font21, _text30, _font22, _text31, _font23, _text32, _font24, _text33, _font25, _text34, _g23, _text35, _g24, _g25, _b3, _text36, _br, _text37, _b4, _br2, _text38, _b5, _br3, _text39, _b6, _br4, _text40, _g26, _text41, _g27, _font26, _text42, _font27, _text43, _font28, _text44, _font29, _text45, _rect, _font30, _text46, _g28, _font31, _br5, _text47;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemiAiNativedrawio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent",
      backgroundColor: "transparent",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "760px",
    height: "564px",
    viewBox: "-0.5 -0.5 760 564",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36\" version=\"26.2.12\" scale=\"1\" border=\"0\"> <diagram name=\"Page-1\" id=\"_FLLRYbJJkbE4zN9NG-3\"> <mxGraphModel dx=\"2379\" dy=\"2377\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"1100\" pageHeight=\"850\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"2\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"1\"> <mxGeometry x=\"-138\" y=\"-341.25\" width=\"760\" height=\"548.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"3\" value=\"\" style=\"group;fontColor=#f96c6c;labelBackgroundColor=#0a0a0a;\" connectable=\"0\" vertex=\"1\" parent=\"2\"> <mxGeometry y=\"28.25\" width=\"760\" height=\"520\" as=\"geometry\" /> </mxCell> <mxCell id=\"4\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#EEE2E2;\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"160\" width=\"460\" height=\"520\" as=\"geometry\" /> </mxCell> <mxCell id=\"5\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"200.48\" y=\"315.39624999999995\" width=\"389.05\" height=\"204.60375\" as=\"geometry\" /> </mxCell> <mxCell id=\"6\" value=\"......\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"5\"> <mxGeometry x=\"317.38289473684205\" y=\"124.59843749999997\" width=\"61.42894736842105\" height=\"39.34687499999998\" as=\"geometry\" /> </mxCell> <mxCell id=\"7\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"199.71\" y=\"398.125\" width=\"399.29\" height=\"116.878125\" as=\"geometry\" /> </mxCell> <mxCell id=\"8\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"7\"> <mxGeometry y=\"11.360074354862224\" width=\"399.29\" height=\"105.51805064513778\" as=\"geometry\" /> </mxCell> <mxCell id=\"9\" value=\"\" style=\"shape=document;whiteSpace=wrap;html=1;boundedLbl=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=24;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"8\"> <mxGeometry y=\"-11.360074354862224\" width=\"399.29\" height=\"116.87812500000001\" as=\"geometry\" /> </mxCell> <mxCell id=\"10\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;SEARCH&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"20.476190476190474\" y=\"17.040548458230067\" width=\"71.66666666666666\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"11\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Security/RBAC&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"102.38095238095238\" y=\"17.040548458230067\" width=\"102.38095238095238\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"12\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;CMS&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"215\" y=\"17.040548458230067\" width=\"51.19047619047619\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"13\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;DMS&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"284.10714285714283\" y=\"17.040548458230067\" width=\"51.19047619047619\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"14\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Workflows&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"20.476190476190474\" y=\"36.70221561087622\" width=\"71.66666666666666\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"15\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Policy Engine&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"102.38095238095238\" y=\"36.70221561087622\" width=\"81.9047619047619\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"16\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;ESB&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"20.476190476190474\" y=\"59.64082728896341\" width=\"81.9047619047619\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"17\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Catalogue&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"209.88095238095238\" y=\"36.70221561087622\" width=\"56.3095238095238\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"18\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Change &lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot;&gt;Central&lt;/font&gt;&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"296.90476190476187\" y=\"36.70221561087622\" width=\"92.14285714285714\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"19\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Dataflow&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"122.85714285714285\" y=\"56.36388276352237\" width=\"92.14285714285714\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"20\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Lake&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"225.2380952380952\" y=\"56.36388276352237\" width=\"92.14285714285714\" height=\"13.107778101764104\" as=\"geometry\" /> </mxCell> <mxCell id=\"21\" value=\"&lt;font face=&quot;poppins&quot;&gt;&lt;span style=&quot;font-size: 12px;&quot;&gt;Common Services -&lt;/span&gt;&lt;font style=&quot;border-color: var(--border-color); font-size: 12px;&quot; color=&quot;#ff230a&quot;&gt;multiple product/component integration&lt;/font&gt;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=24;\" vertex=\"1\" parent=\"7\"> <mxGeometry x=\"24.64\" width=\"350\" height=\"17.040111532293338\" as=\"geometry\" /> </mxCell> <mxCell id=\"22\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"258.53\" y=\"180.2427840909092\" width=\"330.99545454545455\" height=\"312.63\" as=\"geometry\" /> </mxCell> <mxCell id=\"23\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"22\"> <mxGeometry x=\"-61.3\" y=\"81.25\" width=\"392.29\" height=\"231.38\" as=\"geometry\" /> </mxCell> <mxCell id=\"24\" value=\"\" style=\"shape=dataStorage;whiteSpace=wrap;html=1;fixedSize=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;rotation=90;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"140.94\" y=\"-95.82\" width=\"118.44\" height=\"327.2\" as=\"geometry\" /> </mxCell> <mxCell id=\"25\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 12px;&quot;&gt;Business Services -&lt;font color=&quot;#ff0000&quot;&gt;1 codebase&amp;nbsp;&lt;/font&gt;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=24;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"91.14524332591772\" width=\"239.99944382647385\" height=\"33.571554289544245\" as=\"geometry\" /> </mxCell> <mxCell id=\"26\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Domain Specific Service1&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"91.14524332591772\" y=\"33.57155428954426\" width=\"149.99965239154616\" height=\"29.42292225201073\" as=\"geometry\" /> </mxCell> <mxCell id=\"27\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Domain Specific Service2&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"121.14517380422696\" y=\"62.994476541554995\" width=\"149.99965239154616\" height=\"29.42292225201073\" as=\"geometry\" /> </mxCell> <mxCell id=\"28\" value=\"......\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"281.1448030218762\" y=\"62.994476541554995\" width=\"59.99986095661846\" height=\"29.42292225201073\" as=\"geometry\" /> </mxCell> <mxCell id=\"29\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Distributed Federated Data Management&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;\" vertex=\"1\" parent=\"22\"> <mxGeometry x=\"-63.650000000000006\" y=\"14.757215909090789\" width=\"390\" height=\"16.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"30\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Data Connectors&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"194.88\" y=\"243.75\" width=\"390\" height=\"16.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"31\" value=\"&lt;font face=&quot;poppins&quot;&gt;Harmonized Data Definition(Meta Data)&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"194.88\" y=\"219.375\" width=\"390\" height=\"16.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"32\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Harmonized Process Definition(data+business)&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"194.88\" y=\"170.625\" width=\"390\" height=\"16.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"33\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"424.01\" y=\"10\" width=\"169.99\" height=\"147.63\" as=\"geometry\" /> </mxCell> <mxCell id=\"34\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;\" vertex=\"1\" parent=\"33\"> <mxGeometry width=\"169.99\" height=\"147.63\" as=\"geometry\" /> </mxCell> <mxCell id=\"35\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"33\"> <mxGeometry x=\"9.76\" y=\"30\" width=\"150.23\" height=\"110.95\" as=\"geometry\" /> </mxCell> <mxCell id=\"36\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 9px;&quot;&gt;Management &amp;amp; Monitoring&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#FFFFCC;\" vertex=\"1\" parent=\"35\"> <mxGeometry x=\"0.23000000000001813\" y=\"88.76\" width=\"149.99999999999997\" height=\"22.19\" as=\"geometry\" /> </mxCell> <mxCell id=\"37\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 9px;&quot;&gt;Multiagent Context&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#FFFFCC;\" vertex=\"1\" parent=\"35\"> <mxGeometry x=\"0.23000000000001813\" y=\"44.38\" width=\"149.99999999999997\" height=\"22.19\" as=\"geometry\" /> </mxCell> <mxCell id=\"38\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 9px;&quot;&gt;Multiagent Orchestration&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#FFFFCC;\" vertex=\"1\" parent=\"35\"> <mxGeometry width=\"149.99999999999997\" height=\"22.19\" as=\"geometry\" /> </mxCell> <mxCell id=\"39\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 14px;&quot;&gt;&lt;b&gt;ML-Ops&lt;/b&gt;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=8;\" vertex=\"1\" parent=\"33\"> <mxGeometry x=\"51.54000000000002\" width=\"66.66666666666666\" height=\"19.859999999999996\" as=\"geometry\" /> </mxCell> <mxCell id=\"40\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"188\" y=\"8.125\" width=\"230\" height=\"154.375\" as=\"geometry\" /> </mxCell> <mxCell id=\"41\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;direction=south;\" vertex=\"1\" parent=\"40\"> <mxGeometry width=\"230\" height=\"154.375\" as=\"geometry\" /> </mxCell> <mxCell id=\"42\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;AI Agent&lt;/font&gt;\" style=\"shape=umlActor;verticalLabelPosition=bottom;verticalAlign=top;html=1;outlineConnect=0;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"32\" y=\"110.50000000000009\" width=\"18\" height=\"21.4175\" as=\"geometry\" /> </mxCell> <mxCell id=\"43\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;AI Agent&lt;/font&gt;\" style=\"shape=umlActor;verticalLabelPosition=bottom;verticalAlign=top;html=1;outlineConnect=0;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"98\" y=\"110.50000000000009\" width=\"18\" height=\"21.4175\" as=\"geometry\" /> </mxCell> <mxCell id=\"44\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;AI Agent&lt;/font&gt;\" style=\"shape=umlActor;verticalLabelPosition=bottom;verticalAlign=top;html=1;outlineConnect=0;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"163.17000000000002\" y=\"110.50000000000009\" width=\"18\" height=\"21.4175\" as=\"geometry\" /> </mxCell> <mxCell id=\"45\" value=\"&lt;b&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Business Outcome Metric Tree&lt;/font&gt;&lt;/b&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=12;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"20\" y=\"5.13\" width=\"188.42\" height=\"24.38\" as=\"geometry\" /> </mxCell> <mxCell id=\"46\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;KPA1&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#FFFFCC;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"10.479999999999997\" y=\"32.5\" width=\"70\" height=\"16.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"47\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;KPA2&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#FFFFCC;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"4.880000000000003\" y=\"65\" width=\"70\" height=\"16.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"48\" style=\"edgeStyle=none;html=1;fontFamily=Comic Sans MS;fontSize=12;\" edge=\"1\" parent=\"40\" source=\"46\" target=\"47\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"49\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;KPA3&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#FFFFCC;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"86\" y=\"65\" width=\"70\" height=\"16.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"50\" style=\"edgeStyle=none;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;fontFamily=Comic Sans MS;fontSize=12;exitX=0.75;exitY=1;exitDx=0;exitDy=0;\" edge=\"1\" parent=\"40\" source=\"46\" target=\"49\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"50\" y=\"56.875\" as=\"sourcePoint\" /> </mxGeometry> </mxCell> <mxCell id=\"51\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;KPA4&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#FFFFCC;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"4.880000000000003\" y=\"89.375\" width=\"70\" height=\"16.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"52\" style=\"edgeStyle=none;html=1;fontFamily=Comic Sans MS;fontSize=12;\" edge=\"1\" parent=\"40\" source=\"47\" target=\"51\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"53\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;KPA5&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#FFFFCC;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"81.17000000000002\" y=\"89.375\" width=\"70\" height=\"16.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"54\" style=\"edgeStyle=none;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;fontFamily=Comic Sans MS;fontSize=12;\" edge=\"1\" parent=\"40\" source=\"47\" target=\"53\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"55\" value=\"&lt;font style=&quot;font-size: 11px;&quot; data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Agents working on KPA&#39;s of business model&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=12;\" vertex=\"1\" parent=\"40\"> <mxGeometry x=\"149\" y=\"32.5\" width=\"81\" height=\"65\" as=\"geometry\" /> </mxCell> <mxCell id=\"56\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"640\" y=\"146.25\" width=\"80\" height=\"291.28\" as=\"geometry\" /> </mxCell> <mxCell id=\"57\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#EEE2E2;\" vertex=\"1\" parent=\"56\"> <mxGeometry width=\"80\" height=\"291.28\" as=\"geometry\" /> </mxCell> <mxCell id=\"58\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 14px;&quot;&gt;&lt;b&gt;Data&amp;nbsp;&lt;/b&gt;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=8;\" vertex=\"1\" parent=\"56\"> <mxGeometry x=\"6\" y=\"9.929999999999998\" width=\"66.66666666666666\" height=\"19.859999999999996\" as=\"geometry\" /> </mxCell> <mxCell id=\"59\" value=\"&lt;font style=&quot;&quot;&gt;&lt;b style=&quot;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 10px;&quot;&gt;Search&lt;/font&gt;&lt;/b&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"56\"> <mxGeometry x=\"19.333333333333332\" y=\"33.09999999999999\" width=\"40\" height=\"39.71999999999999\" as=\"geometry\" /> </mxCell> <mxCell id=\"60\" value=\"&lt;font style=&quot;&quot;&gt;&lt;span style=&quot;font-size: 10px;&quot;&gt;&lt;b&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;NoSql&lt;/font&gt;&lt;/b&gt;&lt;/span&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"56\"> <mxGeometry x=\"20\" y=\"92.67999999999998\" width=\"40\" height=\"39.71999999999999\" as=\"geometry\" /> </mxCell> <mxCell id=\"61\" value=\"&lt;font style=&quot;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 10px;&quot;&gt;&lt;b&gt;Cache&lt;/b&gt;&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"56\"> <mxGeometry x=\"20\" y=\"158.87999999999997\" width=\"40\" height=\"39.71999999999999\" as=\"geometry\" /> </mxCell> <mxCell id=\"62\" value=\"&lt;font style=&quot;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 10px;&quot;&gt;&lt;b&gt;Vector&lt;/b&gt;&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"56\"> <mxGeometry x=\"20\" y=\"215.14999999999998\" width=\"40\" height=\"39.71999999999999\" as=\"geometry\" /> </mxCell> <mxCell id=\"63\" value=\"&lt;font style=&quot;font-size: 24px;&quot;&gt;.....&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=6;\" vertex=\"1\" parent=\"56\"> <mxGeometry x=\"32.666666666666664\" y=\"261.48999999999995\" width=\"40\" height=\"19.859999999999996\" as=\"geometry\" /> </mxCell> <mxCell id=\"64\" value=\"\" style=\"edgeStyle=none;html=1;fontFamily=Comic Sans MS;fontSize=12;\" edge=\"1\" parent=\"3\" source=\"4\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"640\" y=\"259.1875\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"65\" value=\"\" style=\"group\" connectable=\"0\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"68\" y=\"73.13\" width=\"80\" height=\"376.87\" as=\"geometry\" /> </mxCell> <mxCell id=\"66\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#EEE2E2;\" vertex=\"1\" parent=\"65\"> <mxGeometry width=\"80\" height=\"376.87\" as=\"geometry\" /> </mxCell> <mxCell id=\"67\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Mobile client&lt;/font&gt;\" style=\"sketch=0;outlineConnect=0;fontColor=#232F3E;gradientColor=none;strokeColor=#232F3E;fillColor=#EEE2E2;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.mobile_client;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"65\"> <mxGeometry x=\"13\" width=\"48.75\" height=\"48.75\" as=\"geometry\" /> </mxCell> <mxCell id=\"68\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Applications&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;gradientColor=#F54749;gradientDirection=north;fillColor=#FFCCFF;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.amplify;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"65\"> <mxGeometry x=\"18\" y=\"89.73095238095239\" width=\"40.625\" height=\"40.625\" as=\"geometry\" /> </mxCell> <mxCell id=\"69\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Dashboards&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;gradientColor=#F34482;gradientDirection=north;fillColor=#FFCCFF;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.personal_health_dashboard;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"65\"> <mxGeometry x=\"21\" y=\"242.27357142857144\" width=\"35.75\" height=\"35.75\" as=\"geometry\" /> </mxCell> <mxCell id=\"70\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;CLI&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;gradientColor=#F78E04;gradientDirection=north;fillColor=#D05C17;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.genomics_cli;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"65\"> <mxGeometry x=\"16\" y=\"314.0583333333334\" width=\"39\" height=\"39\" as=\"geometry\" /> </mxCell> <mxCell id=\"71\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Human Query&lt;/font&gt;\" style=\"shape=mxgraph.cisco.people.man_woman;html=1;pointerEvents=1;dashed=0;fillColor=#036897;strokeColor=#ffffff;strokeWidth=2;verticalLabelPosition=bottom;verticalAlign=top;align=center;outlineConnect=0;fontFamily=Comic Sans MS;fontSize=8;\" vertex=\"1\" parent=\"65\"> <mxGeometry x=\"25\" y=\"170.48880952380955\" width=\"30\" height=\"35.89238095238096\" as=\"geometry\" /> </mxCell> <mxCell id=\"72\" value=\"&lt;font style=&quot;font-size: 24px;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Semi AI Native&lt;br&gt;&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=12;\" vertex=\"1\" parent=\"2\"> <mxGeometry x=\"199\" width=\"310\" height=\"29.25\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "drawio-svg-SVkfmrbVCP5HyEvifr_N-gradient-light-dark_f54749_ff7072_-1-light-dark_ffccff_512551_-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCCFF",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(255, 204, 255), rgb(81, 37, 81))",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F54749",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(245, 71, 73), rgb(255, 112, 114))",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "drawio-svg-SVkfmrbVCP5HyEvifr_N-gradient-light-dark_f34482_ff6ba1_-1-light-dark_ffccff_512551_-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCCFF",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(255, 204, 255), rgb(81, 37, 81))",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F34482",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(243, 68, 130), rgb(255, 107, 161))",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "drawio-svg-SVkfmrbVCP5HyEvifr_N-gradient-light-dark_f78e04_b85e00_-1-light-dark_d05c17_e07c41_-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D05C17",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(208, 92, 23), rgb(224, 124, 65))",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F78E04",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(247, 142, 4), rgb(184, 94, 0))",
      stopOpacity: 1
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url(https://fonts.googleapis.com/css2?family=poppins:wght@400;500);&#xa;"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "82dtt1fWFMic4u1b7Cw8-5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-3"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-5"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-6"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-8"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-10"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-11"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-12"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-13"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-14"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-15"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-16"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-17"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-18"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-19"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-20"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-31"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-33"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-34"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-35"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-36"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-37"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-38"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-40"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-41"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-42"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-43"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-44"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-45"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-47"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-48"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-49"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-50"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-51"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-52"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-53"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-54"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-55"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-57"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-58"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-59"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-60"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-62"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-63"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-64"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-65"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-66"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-67"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-68"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-69"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-70"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-71"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-72"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-73"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-78"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-79"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-3"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-21"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-40"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-41"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-42"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-43"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-44"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-45"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-47"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-48"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-49"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-50"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-51"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-52"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-53"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-54"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-64"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-65"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-66"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-67"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-68"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-69"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-70"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-8"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-7"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-12"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-59"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-60"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-58"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-33"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-38"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-35"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-36"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-37"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-10"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-11"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-13"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-14"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-16"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-17"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-18"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-19"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "JAH7sVyCV3_5cxgfEnHs-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "82dtt1fWFMic4u1b7Cw8-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-6"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-8"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-10"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-11"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-12"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-13"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-14"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-15"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-16"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-17"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-18"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-19"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-20"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-21"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-22"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-23"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-24"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-25"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-26"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-31"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-34"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-35"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-36"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-37"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-38"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-39"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-40"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-41"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-43"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-44"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-45"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-47"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-48"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-5"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-3"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-5"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-6"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-7"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-8"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-9"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-10"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-11"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-12"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-13"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-14"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-15"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-16"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-17"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-18"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-19"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-20"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-21"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-22"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-23"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-24"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-25"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-26"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-27"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-28"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-29"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-30"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-31"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-37"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-38"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-39"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-40"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-41"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-42"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-43"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-44"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-45"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-47"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-48"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-49"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-51"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-32"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "JAH7sVyCV3_5cxgfEnHs-2"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-1"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 43,
    width: 460,
    height: 520,
    rx: 69,
    ry: 69,
    fill: "#eee2e2",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-4"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-5"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 517.86,
    y: 482.99,
    width: 61.43,
    height: 39.35,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 59,
      height: 1,
      paddingTop: 503,
      marginLeft: 519
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "......")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 549,
    y: 506,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "......"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-6"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-7"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 199.71 441.12 L 599 441.12 L 599 540.47 Q 499.18 508.91 399.35 540.47 Q 299.53 572.03 199.71 540.47 L 199.71 458.66 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.19,
    y: 469.53,
    width: 71.67,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 70,
      height: 1,
      paddingTop: 476,
      marginLeft: 221
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font || (_font = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "SEARCH")))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 480,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "SEARCH")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 302.09,
    y: 469.53,
    width: 102.38,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 100,
      height: 1,
      paddingTop: 476,
      marginLeft: 303
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font2 || (_font2 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Security/RBAC")))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 353,
    y: 480,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Security/RBAC")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 414.71,
    y: 469.53,
    width: 51.19,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 49,
      height: 1,
      paddingTop: 476,
      marginLeft: 416
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font3 || (_font3 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "CMS")))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 480,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "CMS")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 483.82,
    y: 469.53,
    width: 51.19,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 49,
      height: 1,
      paddingTop: 476,
      marginLeft: 485
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font4 || (_font4 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "DMS")))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 509,
    y: 480,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DMS")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.19,
    y: 489.19,
    width: 71.67,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 70,
      height: 1,
      paddingTop: 496,
      marginLeft: 221
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font5 || (_font5 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Workflows")))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 499,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Workflows")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 302.09,
    y: 489.19,
    width: 81.9,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 80,
      height: 1,
      paddingTop: 496,
      marginLeft: 303
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font6 || (_font6 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Policy Engine")))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 343,
    y: 499,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Policy Engine")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.19,
    y: 512.13,
    width: 81.9,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 80,
      height: 1,
      paddingTop: 519,
      marginLeft: 221
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font7 || (_font7 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "ESB")))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 261,
    y: 522,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ESB")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: 489.19,
    width: 56.31,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 54,
      height: 1,
      paddingTop: 496,
      marginLeft: 411
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font8 || (_font8 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Catalogue")))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 438,
    y: 499,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Catalogue")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 496.61,
    y: 489.19,
    width: 92.14,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 90,
      height: 1,
      paddingTop: 496,
      marginLeft: 498
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font9 || (_font9 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Change ", /*#__PURE__*/React.createElement("font", {
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Central"))))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 543,
    y: 499,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Change Central")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.57,
    y: 508.85,
    width: 92.14,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 90,
      height: 1,
      paddingTop: 515,
      marginLeft: 324
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font10 || (_font10 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Dataflow")))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 369,
    y: 519,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Dataflow")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.95,
    y: 508.85,
    width: 92.14,
    height: 13.11,
    rx: 1.97,
    ry: 1.97,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 90,
      height: 1,
      paddingTop: 515,
      marginLeft: 426
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font11 || (_font11 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Lake")))))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 471,
    y: 519,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Lake"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-20"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.35,
    y: 441.12,
    width: 350,
    height: 17.04,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 348,
      height: 1,
      paddingTop: 450,
      marginLeft: 225
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 24,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12
    }
  }, "Common Services -"), /*#__PURE__*/React.createElement("font", {
    color: "#ff230a",
    style: {
      borderColor: "var(--border-color)",
      fontSize: 12,
      color: "light-dark(rgb(255, 35, 10), rgb(255, 130, 108))"
    }
  }, "multiple product/component integration")))))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 399,
    y: 457,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "24px",
    textAnchor: "middle"
  }, "Common Services -multiple pro..."))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-21"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-22"
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 358.17 208.67 L 456.61 208.67 Q 416.61 372.27 456.61 535.87 L 358.17 535.87 Q 318.17 372.27 358.17 208.67 Z",
    fill: "#ccffff",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    transform: "rotate(90,397.39,372.27)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-24"
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288.38,
    y: 304.49,
    width: 240,
    height: 33.57,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 238,
      height: 1,
      paddingTop: 321,
      marginLeft: 289
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 24,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Business Services -", /*#__PURE__*/React.createElement("font", {
    color: "#ff0000",
    style: {
      color: "light-dark(rgb(255, 0, 0), rgb(255, 144, 144))"
    }
  }, "1 codebase\xA0")))))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 408,
    y: 328,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "24px",
    textAnchor: "middle"
  }, "Business Services -1...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288.38,
    y: 338.06,
    width: 150,
    height: 29.42,
    rx: 4.41,
    ry: 4.41,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 353,
      marginLeft: 289
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font12 || (_font12 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Domain Specific Service1")))))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 363,
    y: 356,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Domain Specific Service1")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-26"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 318.38,
    y: 367.49,
    width: 150,
    height: 29.42,
    rx: 4.41,
    ry: 4.41,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 382,
      marginLeft: 319
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font13 || (_font13 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Domain Specific Service2")))))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 393,
    y: 386,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Domain Specific Service2")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-27"
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 478.37,
    y: 367.49,
    width: 60,
    height: 29.42,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 382,
      marginLeft: 479
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "......")))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 508,
    y: 386,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "......"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.88,
    y: 238,
    width: 390,
    height: 16.25,
    rx: 2.44,
    ry: 2.44,
    fill: "#ccffff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 388,
      height: 1,
      paddingTop: 246,
      marginLeft: 196
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font14 || (_font14 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Distributed Federated Data Management")))))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 250,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Distributed Federated Data Management"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.88,
    y: 286.75,
    width: 390,
    height: 16.25,
    rx: 2.44,
    ry: 2.44,
    fill: "#ccffff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 388,
      height: 1,
      paddingTop: 295,
      marginLeft: 196
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font15 || (_font15 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Data Connectors")))))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 298,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Data Connectors")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.88,
    y: 262.37,
    width: 390,
    height: 16.25,
    rx: 2.44,
    ry: 2.44,
    fill: "#ccffff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 388,
      height: 1,
      paddingTop: 271,
      marginLeft: 196
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font16 || (_font16 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Harmonized Data Definition(Meta Data)")))))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 274,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Harmonized Data Definition(Meta Data)")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-32"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.88,
    y: 213.62,
    width: 390,
    height: 16.25,
    rx: 2.44,
    ry: 2.44,
    fill: "#ccffff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 388,
      height: 1,
      paddingTop: 222,
      marginLeft: 196
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font17 || (_font17 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Harmonized Process Definition(data+business)")))))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 225,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Harmonized Process Definition(data+business)")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-33"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.01,
    y: 53,
    width: 169.99,
    height: 147.63,
    rx: 22.14,
    ry: 22.14,
    fill: "#ccffff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-35"
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 171.76,
    width: 150,
    height: 22.19,
    rx: 3.33,
    ry: 3.33,
    fill: "#ffffcc",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 204), rgb(24, 24, 0))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 183,
      marginLeft: 435
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Management &amp; Monitoring"))))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 509,
    y: 186,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Management &amp; Monitoring")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-37"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 127.38,
    width: 150,
    height: 22.19,
    rx: 3.33,
    ry: 3.33,
    fill: "#ffffcc",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 204), rgb(24, 24, 0))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 138,
      marginLeft: 435
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Multiagent Context"))))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 509,
    y: 142,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Multiagent Context")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 433.77,
    y: 83,
    width: 150,
    height: 22.19,
    rx: 3.33,
    ry: 3.33,
    fill: "#ffffcc",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 204), rgb(24, 24, 0))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 94,
      marginLeft: 435
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Multiagent Orchestration"))))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 509,
    y: 98,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Multiagent Orchestration"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-1"
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 475.55,
    y: 53,
    width: 66.67,
    height: 19.86,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 65,
      height: 1,
      paddingTop: 63,
      marginLeft: 477
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 8,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "ML-Ops"))))))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 509,
    y: 65,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "8px",
    textAnchor: "middle"
  }, "ML-Ops"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-39"
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.81,
    y: 13.31,
    width: 154.37,
    height: 230,
    rx: 23.16,
    ry: 23.16,
    fill: "#ccffff",
    stroke: "#0066cc",
    transform: "rotate(90,303,128.31)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 229,
    cy: 164.3,
    rx: 4.499999999999999,
    ry: 2.6771874999999996,
    fill: "#ccffff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 229 166.98 L 229 175.9 M 229 168.76 L 220 168.76 M 229 168.76 L 238 168.76 M 229 175.9 L 220 183.04 M 229 175.9 L 238 183.04",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 190,
      marginLeft: 229
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font18 || (_font18 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "AI Agent")))))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 202,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "AI...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 295,
    cy: 164.3,
    rx: 4.499999999999999,
    ry: 2.6771874999999996,
    fill: "#ccffff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 295 166.98 L 295 175.9 M 295 168.76 L 286 168.76 M 295 168.76 L 304 168.76 M 295 175.9 L 286 183.04 M 295 175.9 L 304 183.04",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 190,
      marginLeft: 295
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font19 || (_font19 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "AI Agent")))))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 295,
    y: 202,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "AI...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.17,
    cy: 164.3,
    rx: 4.499999999999999,
    ry: 2.6771874999999996,
    fill: "#ccffff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.17 166.98 L 360.17 175.9 M 360.17 168.76 L 351.17 168.76 M 360.17 168.76 L 369.17 168.76 M 360.17 175.9 L 351.17 183.04 M 360.17 175.9 L 369.17 183.04",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 190,
      marginLeft: 360
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font20 || (_font20 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "AI Agent")))))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 202,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "AI...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-44"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 56.26,
    width: 188.42,
    height: 24.38,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 186,
      height: 1,
      paddingTop: 68,
      marginLeft: 209
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _b2 || (_b2 = /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Business Outcome Metric Tree"))))))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 302,
    y: 72,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Business Outcome Metric Tree")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.48,
    y: 83.62,
    width: 70,
    height: 16.25,
    rx: 2.44,
    ry: 2.44,
    fill: "#ffffcc",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 204), rgb(24, 24, 0))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 68,
      height: 1,
      paddingTop: 92,
      marginLeft: 199
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font21 || (_font21 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "KPA1")))))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 233,
    y: 95,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "KPA1")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-46"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.88,
    y: 116.12,
    width: 70,
    height: 16.25,
    rx: 2.44,
    ry: 2.44,
    fill: "#ffffcc",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 204), rgb(24, 24, 0))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 68,
      height: 1,
      paddingTop: 124,
      marginLeft: 194
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font22 || (_font22 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "KPA2")))))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 128,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "KPA2")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 232.08 99.87 L 230.36 109.85",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 229.47 115.02 L 227.21 107.53 L 230.36 109.85 L 234.11 108.72 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-48"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 116.12,
    width: 70,
    height: 16.25,
    rx: 2.44,
    ry: 2.44,
    fill: "#ffffcc",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 204), rgb(24, 24, 0))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 68,
      height: 1,
      paddingTop: 124,
      marginLeft: 275
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font23 || (_font23 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "KPA3")))))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 309,
    y: 128,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "KPA3")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-49"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 250.98 99.87 L 302.87 114.41",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 307.92 115.82 L 300.24 117.31 L 302.87 114.41 L 302.13 110.57 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.88,
    y: 140.5,
    width: 70,
    height: 16.25,
    rx: 2.44,
    ry: 2.44,
    fill: "#ffffcc",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 204), rgb(24, 24, 0))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 68,
      height: 1,
      paddingTop: 149,
      marginLeft: 194
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font24 || (_font24 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "KPA4")))))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 152,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "KPA4")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-51"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 227.88 132.37 L 227.88 134.13",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 227.88 139.38 L 224.38 132.38 L 227.88 134.13 L 231.38 132.38 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-52"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 269.17,
    y: 140.5,
    width: 70,
    height: 16.25,
    rx: 2.44,
    ry: 2.44,
    fill: "#ffffcc",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 204), rgb(24, 24, 0))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 68,
      height: 1,
      paddingTop: 149,
      marginLeft: 270
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font25 || (_font25 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "KPA5")))))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 152,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "KPA5")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-53"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 262.88 131.71 L 297.94 139.17",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 303.08 140.27 L 295.5 142.23 L 297.94 139.17 L 296.96 135.39 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-54"
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 83.62,
    width: 81,
    height: 65,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 79,
      height: 1,
      paddingTop: 116,
      marginLeft: 338
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins",
    style: {
      fontSize: 11
    }
  }, "Agents working on KPA's of business model"))))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 378,
    y: 120,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Agents workin..."))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-57"
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-58"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 189.25,
    width: 80,
    height: 291.28,
    rx: 12,
    ry: 12,
    fill: "#eee2e2",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-59"
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 199.18,
    width: 66.67,
    height: 19.86,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 65,
      height: 1,
      paddingTop: 209,
      marginLeft: 647
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 8,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, _b3 || (_b3 = /*#__PURE__*/React.createElement("b", null, "Data\xA0"))))))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 679,
    y: 212,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "8px",
    textAnchor: "middle"
  }, "Data\xA0")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 659.33 227.35 C 659.33 220.68 699.33 220.68 699.33 227.35 L 699.33 257.07 C 699.33 263.74 659.33 263.74 659.33 257.07 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659.33 227.35 C 659.33 232.35 699.33 232.35 699.33 227.35 M 659.33 229.85 C 659.33 234.85 699.33 234.85 699.33 229.85 M 659.33 232.35 C 659.33 237.35 699.33 237.35 699.33 232.35",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 249,
      marginLeft: 660
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("b", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 10
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Search")), _br || (_br = /*#__PURE__*/React.createElement("br", null))))))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 679,
    y: 253,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Search&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 660 286.93 C 660 280.26 700 280.26 700 286.93 L 700 316.65 C 700 323.32 660 323.32 660 316.65 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660 286.93 C 660 291.93 700 291.93 700 286.93 M 660 289.43 C 660 294.43 700 294.43 700 289.43 M 660 291.93 C 660 296.93 700 296.93 700 291.93",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 309,
      marginLeft: 661
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 10
    }
  }, _b4 || (_b4 = /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "NoSql")))), _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null))))))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 313,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "NoSql&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-62"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 660 353.13 C 660 346.46 700 346.46 700 353.13 L 700 382.85 C 700 389.52 660 389.52 660 382.85 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660 353.13 C 660 358.13 700 358.13 700 353.13 M 660 355.63 C 660 360.63 700 360.63 700 355.63 M 660 358.13 C 660 363.13 700 363.13 700 358.13",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 375,
      marginLeft: 661
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 10
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, _b5 || (_b5 = /*#__PURE__*/React.createElement("b", null, "Cache"))), _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null))))))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 379,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Cache&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-63"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 660 409.4 C 660 402.73 700 402.73 700 409.4 L 700 439.12 C 700 445.79 660 445.79 660 439.12 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660 409.4 C 660 414.4 700 414.4 700 409.4 M 660 411.9 C 660 416.9 700 416.9 700 411.9 M 660 414.4 C 660 419.4 700 419.4 700 414.4",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 431,
      marginLeft: 661
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 10
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, _b6 || (_b6 = /*#__PURE__*/React.createElement("b", null, "Vector"))), _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null))))))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 435,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Vector&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-64"
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 672.67,
    y: 450.74,
    width: 40,
    height: 19.86,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 461,
      marginLeft: 674
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 6,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 24
    }
  }, "....."))))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 693,
    y: 462,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "6px",
    textAnchor: "middle"
  }, "....."))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-65"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 620 302.25 L 633.63 302.21",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 638.88 302.19 L 631.89 305.71 L 633.63 302.21 L 631.87 298.71 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-66"
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-67"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 116.13,
    width: 80,
    height: 376.87,
    rx: 12,
    ry: 12,
    fill: "#eee2e2",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-68"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 81 116.13 L 129.75 116.13 L 129.75 164.88 L 81 164.88 Z",
    fill: "#eee2e2",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.47 124.66 C 101.62 124.66 101.74 124.78 101.74 124.94 C 101.74 125.09 101.62 125.21 101.47 125.21 C 101.32 125.21 101.19 125.09 101.19 124.94 C 101.19 124.78 101.32 124.66 101.47 124.66 Z M 101.47 126.54 C 102.36 126.54 103.08 125.82 103.08 124.94 C 103.08 124.05 102.36 123.33 101.47 123.33 C 100.58 123.33 99.86 124.05 99.86 124.94 C 99.86 125.82 100.58 126.54 101.47 126.54 Z M 104.5 125.81 L 109.27 125.81 L 109.27 124.03 L 104.5 124.03 Z M 112.65 158.23 L 98.09 158.23 C 97.21 158.23 96.48 157.52 96.48 156.64 L 96.48 155.39 L 114.27 155.39 L 114.27 156.64 C 114.27 157.52 113.54 158.23 112.65 158.23 Z M 96.48 128.84 L 114.27 128.84 L 114.27 153.61 L 96.48 153.61 L 96.48 144.98 Z M 98.84 122.78 L 111.91 122.78 C 113.21 122.78 114.27 123.82 114.27 125.1 L 114.27 127.06 L 96.48 127.06 L 96.48 125.1 C 96.48 123.82 97.54 122.78 98.84 122.78 Z M 111.93 121.01 L 111.91 121.01 L 98.84 121.01 C 96.56 121.01 94.7 122.84 94.7 125.1 L 94.7 156.64 C 94.7 158.5 96.22 160.01 98.09 160.01 L 112.65 160.01 C 114.53 160.01 116.05 158.5 116.05 156.64 L 116.05 125.1 L 116.05 125.1 C 116.05 122.84 114.2 121.01 111.93 121.01 Z",
    fill: "#232f3e",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(35, 47, 62), rgb(189, 199, 212))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 172,
      marginLeft: 105
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font26 || (_font26 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Mobile client")))))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 184,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Mobile c...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-69"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 86 205.86 L 126.62 205.86 L 126.62 246.49 L 86 246.49 Z",
    fill: "url(#drawio-svg-SVkfmrbVCP5HyEvifr_N-gradient-light-dark_f54749_ff7072_-1-light-dark_ffccff_512551_-1-s-0)",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 117.67 237.52 L 106.03 214.82 L 109.36 214.82 L 121.01 237.52 Z M 122.47 237.84 L 110.23 213.98 C 110.13 213.79 109.93 213.67 109.71 213.67 L 105.08 213.67 C 104.88 213.67 104.69 213.77 104.58 213.94 C 104.48 214.12 104.47 214.33 104.56 214.51 L 116.8 238.37 C 116.9 238.56 117.1 238.68 117.32 238.68 L 121.95 238.68 C 122.16 238.68 122.34 238.58 122.45 238.4 C 122.55 238.23 122.56 238.02 122.47 237.84 Z M 110.71 237.52 L 101.8 220.81 L 103.63 217.79 L 114.04 237.52 Z M 104.17 216.34 C 104.08 216.16 103.89 216.04 103.68 216.04 C 103.48 216.02 103.27 216.14 103.17 216.31 L 100.64 220.49 C 100.53 220.67 100.53 220.88 100.62 221.07 L 109.86 238.37 C 109.96 238.56 110.15 238.68 110.37 238.68 L 115 238.68 C 115.21 238.68 115.39 238.57 115.5 238.4 C 115.6 238.23 115.61 238.01 115.51 237.83 Z M 91.7 237.52 L 99.87 224 L 101.54 227.12 L 97.7 233.76 C 97.6 233.94 97.6 234.16 97.7 234.34 C 97.8 234.52 97.99 234.63 98.2 234.63 L 105.54 234.63 L 107.08 237.52 Z M 106.4 233.77 C 106.3 233.59 106.1 233.47 105.89 233.47 L 99.21 233.47 L 102.7 227.43 C 102.8 227.25 102.81 227.04 102.71 226.86 L 100.42 222.56 C 100.32 222.37 100.13 222.26 99.92 222.25 C 99.7 222.24 99.52 222.35 99.41 222.53 L 90.17 237.8 C 90.07 237.98 90.06 238.2 90.17 238.39 C 90.27 238.57 90.46 238.68 90.67 238.68 L 108.05 238.68 C 108.25 238.68 108.44 238.57 108.55 238.4 C 108.65 238.23 108.66 238.01 108.56 237.83 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 253,
      marginLeft: 106
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font27 || (_font27 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Applications")))))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 265,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Applica...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-70"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 89 358.4 L 124.75 358.4 L 124.75 394.15 L 89 394.15 Z",
    fill: "url(#drawio-svg-SVkfmrbVCP5HyEvifr_N-gradient-light-dark_f34482_ff6ba1_-1-light-dark_ffccff_512551_-1-s-0)",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 92.57 377.86 L 93.63 377.86 L 93.63 376.8 L 92.57 376.8 Z M 111.09 368.7 C 111.02 368.48 110.82 368.33 110.58 368.33 L 110.58 368.33 C 110.35 368.33 110.15 368.47 110.08 368.69 L 106.75 379.16 L 103.63 373.37 C 103.54 373.2 103.37 373.09 103.17 373.09 L 103.17 373.09 C 102.98 373.09 102.8 373.19 102.71 373.36 L 100.74 376.8 L 94.69 376.8 L 94.69 377.86 L 101.05 377.86 C 101.24 377.86 101.42 377.76 101.51 377.59 L 103.15 374.71 L 106.41 380.76 C 106.5 380.93 106.68 381.04 106.87 381.04 C 106.89 381.04 106.91 381.03 106.92 381.03 C 107.14 381.01 107.32 380.87 107.38 380.67 L 110.58 370.62 L 112.73 377.49 C 112.79 377.71 113 377.86 113.23 377.86 L 121.17 377.86 L 121.17 376.8 L 113.62 376.8 Z M 106.88 388.65 L 99.25 378.8 L 98.41 379.45 L 106.46 389.83 C 106.56 389.96 106.7 390.06 106.87 390.04 C 107.04 390.04 107.19 389.96 107.29 389.83 L 115.39 379.45 L 114.56 378.8 Z M 93.48 373.13 C 92.87 372.01 92.57 370.89 92.57 369.76 C 92.57 365.76 95.91 362.5 100.01 362.5 C 103.29 362.5 105.82 363.98 106.87 366.31 C 107.93 363.98 110.46 362.5 113.74 362.5 C 117.84 362.5 121.17 365.76 121.17 369.76 C 121.17 370.87 120.88 371.98 120.31 373.06 C 120.14 373.38 119.94 373.69 119.69 374.03 L 119.22 374.58 L 117.86 376.09 L 117.07 375.39 L 118.86 373.37 C 119.06 373.11 119.23 372.83 119.37 372.56 C 119.87 371.63 120.12 370.69 120.12 369.76 C 120.12 366.34 117.26 363.56 113.74 363.56 C 110.59 363.56 107.4 365.2 107.4 368.86 C 107.4 369.15 107.17 369.38 106.87 369.38 C 106.58 369.38 106.35 369.15 106.35 368.86 C 106.35 365.2 103.16 363.56 100.01 363.56 C 96.5 363.56 93.63 366.34 93.63 369.76 C 93.63 370.71 93.89 371.67 94.4 372.6 L 96.2 375.41 L 95.31 375.98 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 401,
      marginLeft: 107
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font28 || (_font28 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Dashboards")))))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 107,
    y: 413,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Dashbo...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-71"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 84 430.19 L 123 430.19 L 123 469.19 L 84 469.19 Z",
    fill: "url(#drawio-svg-SVkfmrbVCP5HyEvifr_N-gradient-light-dark_f78e04_b85e00_-1-light-dark_d05c17_e07c41_-1-s-0)",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111.38 439.14 L 115.68 439.14 L 115.68 438.03 L 111.38 438.03 Z M 110.74 436.28 L 116.31 436.28 L 116.31 435.16 L 110.74 435.16 Z M 111.3 451.36 L 115.76 451.36 L 115.76 450.25 L 111.3 450.25 Z M 110.74 454.15 L 116.31 454.15 L 116.31 453.03 L 110.74 453.03 Z M 99.99 453.43 C 100.21 453.21 100.21 452.85 99.99 452.64 L 93.31 445.95 L 92.52 446.74 L 98.81 453.03 L 92.52 459.32 L 93.31 460.11 Z M 100.16 459.72 L 111.3 459.72 L 111.3 458.6 L 100.16 458.6 Z M 119.1 464.17 L 119.1 458.6 L 117.99 458.6 L 117.99 464.17 L 89.01 464.17 L 89.01 435.2 L 104.61 435.2 L 104.61 434.09 L 89.01 434.09 C 88.4 434.09 87.9 434.59 87.9 435.2 L 87.9 464.17 C 87.9 464.79 88.4 465.29 89.01 465.29 L 117.99 465.29 C 118.6 465.29 119.1 464.79 119.1 464.17 Z M 109.07 452.87 C 109.07 451.2 109.7 449.58 110.85 448.36 L 117.02 441.75 C 118.36 440.31 119.1 438.44 119.1 436.48 L 119.1 434.09 L 117.99 434.09 L 117.99 436.48 C 117.99 438.15 117.35 439.76 116.21 440.99 L 110.03 447.6 C 108.69 449.04 107.96 450.91 107.96 452.87 L 107.96 455.26 L 109.07 455.26 Z M 115.05 445.49 L 114.29 446.31 L 116.21 448.36 C 117.35 449.58 117.99 451.2 117.99 452.87 L 117.99 455.26 L 119.1 455.26 L 119.1 452.87 C 119.1 450.91 118.36 449.04 117.02 447.6 Z M 110.03 441.75 C 108.69 440.31 107.96 438.44 107.96 436.48 L 107.96 434.09 L 109.07 434.09 L 109.07 436.48 C 109.07 438.15 109.7 439.76 110.85 440.99 L 112.77 443.04 L 112 443.86 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 476,
      marginLeft: 104
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font29 || (_font29 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "CLI")))))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 488,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "CLI")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-72"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 286.62,
    width: 30,
    height: 35.89,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 111 318.33 C 110.25 319.56 110.25 319.56 110.25 319.56 C 110.25 319.56 110.25 320.05 111.15 319.8 C 111.9 319.56 111.9 319.56 111.9 319.56 C 112.65 318.82 112.65 318.82 112.65 318.82 C 112.8 318.7 112.8 318.7 112.8 318.7 C 112.8 318.45 112.8 318.33 112.8 318.09 C 112.95 317.72 112.8 317.23 112.95 316.86 C 113.25 316 113.7 315.14 114.15 314.28 C 114.45 313.54 114 312.8 114.3 312.06 C 111.9 311.45 111.9 311.45 111.9 311.45 C 111.75 313.54 111.75 315.5 111.6 317.6 C 111.45 317.84 111.15 318.09 110.85 318.33 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 117.3 318.21 C 117.3 318.21 117.3 318.21 117.3 318.21 C 117.3 318.45 117.3 318.45 117.3 318.45 C 117.9 319.07 117.9 319.07 117.9 319.07 C 119.1 319.8 119.1 319.8 119.1 319.8 C 119.7 319.8 119.7 319.8 119.7 319.8 C 120 319.44 120.15 319.31 120.15 319.31 C 119.7 318.95 119.25 318.7 118.95 318.21 C 118.8 317.96 118.65 317.6 118.65 317.35 C 118.8 315.38 118.95 313.41 119.25 311.57 C 116.85 312.06 116.85 312.06 116.85 312.06 C 116.55 312.06 116.7 312.31 116.7 312.43 C 116.55 312.92 116.55 313.29 116.7 313.78 C 116.7 314.15 117 314.52 117 315.01 C 117.3 316.12 117.45 317.1 117.3 318.21 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 99.75 287.85 C 99.75 287.97 99.75 288.09 99.9 288.22 C 99.9 288.58 99.75 288.95 99.6 289.32 C 99.45 289.44 99.45 289.69 99.3 289.69 C 99.15 289.57 99 289.32 98.85 289.32 C 98.7 289.2 98.4 289.44 98.25 289.57 C 98.7 289.94 99.15 290.43 98.85 290.92 C 98.4 290.31 97.95 289.81 97.5 289.07 C 97.35 288.71 97.35 288.22 97.65 287.97 C 98.1 287.48 98.7 287.11 99.3 286.99 C 100.2 286.74 101.1 286.62 102.15 286.62 C 101.25 286.99 100.5 287.36 99.6 287.73 C 99.6 287.85 99.6 287.85 99.75 287.85 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 102.9 287.97 C 102.6 288.34 102.45 288.58 102.15 288.95 C 102.3 288.83 102.15 288.83 102.15 288.83 C 102 288.83 101.85 288.83 101.85 288.83 C 101.7 288.71 101.7 288.58 101.85 288.58 C 101.85 288.46 102.15 288.58 102.15 288.58 C 102.6 287.97 101.7 287.6 101.55 287.11 C 102.15 287.11 102.6 287.48 103.2 287.48 C 103.05 287.6 102.9 287.85 102.9 287.97 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100.65 288.83 C 100.5 288.83 100.35 288.95 100.35 288.83 C 100.2 288.34 100.95 288.58 101.25 288.46 C 101.25 288.83 100.95 288.95 100.65 288.83 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.55 289.69 C 101.4 289.69 101.4 289.69 101.25 289.69 C 101.4 289.57 101.55 289.44 101.7 289.32 C 101.7 289.44 101.7 289.57 101.85 289.69 C 101.7 289.69 101.7 289.69 101.55 289.69 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.55 290.31 C 101.25 290.31 100.95 290.31 100.65 290.31 C 100.8 290.18 100.95 290.18 100.95 290.18 C 101.25 290.06 101.7 289.94 101.85 290.31 C 101.7 290.31 101.55 290.31 101.55 290.31 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.4 290.43 C 101.7 290.55 101.4 290.55 101.4 290.55 C 101.25 290.68 101.1 290.55 101.1 290.43 C 101.25 290.43 101.25 290.43 101.4 290.43 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 103.65 320.67 C 104.55 321.16 105.3 321.53 106.05 322.02 C 105.9 322.14 105.9 322.26 105.9 322.26 C 105.3 322.26 104.55 322.26 103.95 322.26 C 103.35 322.14 102.9 321.9 102.3 321.65 C 102.3 321.65 102.15 321.9 102.15 321.9 C 101.7 322.02 101.1 321.9 100.8 321.65 C 100.5 321.53 100.8 321.04 100.65 320.79 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100.65 320.79 C 100.65 320.79 100.5 320.79 100.5 320.79 C 100.35 316.36 100.5 311.94 100.35 307.51 C 99.45 311.82 98.7 316 97.65 320.54 C 97.65 320.54 97.35 320.54 97.35 320.67 C 94.65 320.67 94.65 320.67 94.65 320.67 C 94.8 320.42 94.65 320.17 94.65 319.93 C 94.95 317.6 95.4 315.26 95.55 312.92 C 95.55 310.59 95.7 308.25 95.85 305.79 C 95.85 305.43 96.15 304.93 96 304.56 C 96 304.44 95.7 304.32 95.55 304.32 C 95.7 303.95 95.85 303.46 96 303.09 C 95.1 302.35 94.2 301.61 93.45 300.75 C 93.15 300.51 93 300.02 93 299.65 C 93.15 297.68 93.75 295.59 93.75 293.5 C 94.95 292.89 96.45 292.76 97.8 292.27 C 98.25 292.15 98.7 291.9 98.85 291.41 C 99.6 291.78 100.05 292.27 100.8 292.64 C 100.95 292.64 100.95 292.52 100.95 292.39 C 101.1 292.39 101.1 292.39 101.1 292.39 C 101.1 292.27 101.1 292.15 101.25 292.02 C 101.25 292.02 101.25 292.02 101.25 291.9 C 101.4 291.9 101.4 291.66 101.55 291.66 C 101.55 291.78 101.85 291.9 102 292.02 C 103.05 292.39 104.1 292.64 105.15 293.01 C 105.45 293.13 105.9 293.38 106.05 293.63 C 106.2 293.87 106.05 294.12 106.05 294.48 C 105.9 294.73 105.75 295.1 105.75 295.47 C 105.75 296.82 106.2 298.29 106.35 299.77 C 105.6 300.51 105 301.37 104.4 302.23 C 104.55 302.97 104.85 303.58 104.85 304.32 C 104.85 304.32 104.4 304.44 104.4 304.56 C 104.4 305.3 104.55 306.16 104.55 307.02 C 104.25 311.57 104.25 316.12 103.65 320.67 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97.35 320.67 C 97.2 320.91 97.5 321.28 97.35 321.53 C 97.05 321.77 96.6 321.9 96.15 322.14 C 96 322.14 96.15 322.39 95.85 322.39 C 95.1 322.51 94.35 322.51 93.45 322.51 C 93.6 322.14 93.45 321.77 93.6 321.53 C 93.9 321.16 94.5 321.04 94.65 320.67 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.45 299.16 C 96.45 298.54 96.45 298.05 96.3 297.43 C 96 297.93 95.85 298.54 95.85 299.16 C 95.85 299.4 96.3 299.65 96.45 299.89 C 96.6 299.65 96.45 299.4 96.45 299.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 112.35 293.13 C 112.2 293.01 111.9 293.01 111.9 292.76 C 112.05 292.76 112.35 292.76 112.5 292.64 C 112.05 292.52 111.9 292.27 111.9 292.02 C 111.9 291.9 112.05 291.78 112.05 291.78 C 112.2 291.78 112.2 292.02 112.35 292.02 C 112.35 292.15 112.5 292.02 112.5 292.02 C 112.5 291.9 112.5 291.78 112.35 291.53 C 112.65 291.66 112.95 291.66 112.95 291.53 C 112.95 291.29 112.5 291.04 112.8 290.8 C 112.95 290.8 113.1 291.04 113.25 290.92 C 113.25 290.68 112.95 290.55 112.95 290.31 C 112.95 290.18 113.25 290.18 113.4 290.06 C 113.4 289.81 113.25 289.44 113.25 289.32 C 113.55 288.71 114 288.09 114.3 287.6 C 115.2 287.48 115.65 286.74 117.15 287.48 C 117.15 287.48 117 287.48 117 287.48 C 117 287.6 117 287.6 117.15 287.6 C 117.3 287.6 117.6 287.6 117.75 287.73 C 117.75 287.85 117.6 288.09 117.6 288.22 C 117.75 288.34 118.2 288.34 118.2 288.46 C 118.2 288.71 117.75 289.07 117.9 289.32 C 117.9 289.57 118.35 289.57 118.5 289.81 C 118.65 290.06 118.5 290.31 118.65 290.55 C 118.8 290.43 118.95 290.43 119.1 290.31 C 119.1 290.55 119.25 290.68 119.25 290.8 C 119.4 290.68 119.7 290.55 119.85 290.31 C 120 290.43 119.85 290.68 119.85 290.68 C 119.55 290.92 119.25 291.17 118.95 291.17 C 118.95 291.29 118.95 291.29 118.8 291.29 C 118.5 291.04 118.5 291.04 118.5 291.04 C 118.35 291.17 118.8 291.29 118.65 291.29 C 118.65 291.53 118.65 291.53 118.65 291.53 C 118.8 291.78 119.1 291.53 119.4 291.53 C 119.55 291.9 118.95 291.9 118.95 292.15 C 118.8 292.27 119.1 292.27 119.25 292.27 C 119.25 292.52 118.95 292.64 118.8 292.76",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.15 319.31 C 120.6 319.56 120.9 320.05 121.2 320.3 C 121.2 320.42 121.05 320.54 120.9 320.54 C 120.15 320.54 119.55 320.67 118.95 320.42 C 118.5 320.3 118.35 319.68 117.75 319.44 C 117.45 319.56 117.6 319.8 117.45 320.05 C 117.45 320.05 117.3 320.05 117.3 320.05 C 117.15 319.44 116.55 318.7 117.3 318.21 C 117.3 318.21 117.3 318.21 117.3 318.21 C 117.3 318.33 117.3 318.33 117.3 318.33 C 117.9 319.07 117.9 319.07 117.9 319.07 C 119.1 319.8 119.1 319.8 119.1 319.8 C 119.7 319.8 119.7 319.8 119.7 319.8 C 120 319.31 120.15 319.31 120.15 319.31 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 114.3 312.31 C 114.45 312.06 114.9 312.06 115.35 312.06 C 115.5 312.06 115.5 312.43 115.65 312.43 C 115.95 312.43 116.25 312.06 116.55 312.06 C 116.7 312.06 116.7 312.19 116.85 312.31 C 117.75 312.06 117.75 312.06 117.75 312.06 C 118.65 312.43 118.65 312.43 118.65 312.43 C 119.1 311.82 119.1 311.82 119.1 311.82 C 119.25 311.82 119.25 311.82 119.25 311.82 C 119.25 311.7 119.4 311.7 119.4 311.7 C 119.85 309.36 119.85 307.02 120.3 304.56 C 120.3 304.32 120.15 303.95 120.15 303.58 C 120.3 303.58 120.45 303.46 120.6 303.58 C 120.6 302.97 120.3 302.48 120.3 301.98 C 121.2 301.12 122.1 300.26 122.85 299.28 C 123 299.16 123 298.79 122.85 298.54 C 122.55 297.8 122.25 297.07 121.95 296.33 C 121.5 295.22 121.05 294.12 120.6 293.01 C 120 292.89 119.4 292.89 118.8 292.76 C 116.1 292.52 116.1 292.52 116.1 292.52 C 112.35 293.13 112.35 293.13 112.35 293.13 C 111.6 293.38 110.7 293.63 109.95 293.99 C 109.8 295.1 109.95 296.08 109.8 297.19 C 109.65 297.8 109.5 298.29 109.35 298.91 C 109.35 299.16 109.2 299.4 109.35 299.65 C 109.5 300.02 109.5 300.38 109.65 300.63 C 110.4 301.24 111.3 301.49 112.05 302.11 C 112.05 302.48 111.9 302.84 111.75 303.34 C 111.6 303.46 111.9 303.46 111.9 303.46 C 111.9 303.7 111.6 304.07 111.6 304.32 C 111.3 306.78 111.3 309.24 111.45 311.7 C 111.45 311.7 111.9 311.57 111.9 311.7 C 112.5 312.19 112.5 312.19 112.5 312.19 C 113.55 311.94 113.55 311.94 113.55 311.94 C 114.3 312.43 114.3 312.43 114.3 312.43",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118.05 291.78 C 117.9 291.66 117.6 291.53 117.45 291.41 C 117.45 291.53 117.3 291.53 117.3 291.53 C 117.3 291.78 117.15 292.02 117.45 292.02 C 117.6 292.02 117.45 291.78 117.45 291.66 C 117.6 291.78 117.6 291.9 117.75 291.9 C 117.9 292.02 117.9 291.9 118.05 291.78 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 117.3 293.87 C 117.3 293.87 117.3 293.87 117.15 293.87 C 117.15 293.75 117.15 293.75 117.15 293.63 C 117.3 293.63 117.3 293.63 117.45 293.63 C 117.45 293.75 117.45 293.75 117.45 293.75 C 117.6 293.38 117.45 293.01 117.45 292.76 C 117.45 292.64 117.15 292.64 117 292.52 C 116.85 292.27 116.7 291.53 117 291.66 C 117.6 291.66 117.6 290.68 117.75 290.06 C 117.9 289.81 117.75 289.69 117.6 289.44 C 117.6 289.44 117.6 289.57 117.6 289.57 C 117.45 289.69 117.15 289.69 117.15 289.69 C 117 289.57 117 289.44 117.15 289.44 C 117.15 289.32 117.75 289.2 117.75 289.32 C 117.75 288.95 117.6 288.83 117.45 288.58 C 117.3 288.71 117.15 288.71 117 288.71 C 117.15 288.58 117.15 288.34 117 288.34 C 116.7 288.46 116.7 288.83 116.25 288.83 C 116.25 288.71 116.25 288.58 116.25 288.46 C 116.1 288.58 115.95 288.83 115.65 288.83 C 115.65 288.83 115.65 288.46 115.5 288.58 C 115.2 288.83 115.65 288.95 115.5 289.2 C 115.35 289.69 115.35 290.06 115.05 290.55 C 115.05 290.55 115.05 290.68 115.05 290.8 C 115.05 290.8 115.2 290.92 115.35 290.92 C 115.35 291.04 115.2 290.92 115.05 291.04 C 115.05 291.17 115.05 291.17 115.05 291.29 C 115.2 291.41 115.35 291.41 115.65 291.41 C 115.5 291.66 115.2 291.78 114.9 291.53 C 114.75 291.9 115.05 292.15 115.35 292.27 C 115.2 292.39 114.9 292.27 114.75 292.39 C 114.6 292.52 114.75 292.76 114.75 292.89 C 114.75 292.89 114.6 292.89 114.6 292.89 C 114.45 293.13 114.6 293.38 114.75 293.63 C 114.75 293.5 114.75 293.5 114.9 293.5 C 115.05 293.63 114.9 293.63 114.9 293.75 C 114.9 293.75 114.75 293.75 114.75 293.75 C 114.6 293.87 114.75 293.87 114.75 293.99 C 115.35 294.24 115.95 294.36 116.55 294.36 C 116.7 294.36 117 294.24 117.15 294.12 C 117 293.99 116.7 294.12 116.85 293.87 C 116.85 293.75 117 293.87 117.15 293.87 C 117.15 293.87 117 293.99 117.15 294.12 C 117.15 294.12 117.15 294.12 117.15 294.12 C 117.3 293.99 117.6 293.99 117.6 293.87 C 117.6 293.87 117.6 293.75 117.45 293.75 C 117.45 293.75 117.45 293.87 117.3 293.87 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 116.55 289.69 C 116.55 289.69 116.55 289.69 116.55 289.69 C 116.25 289.69 115.95 289.69 115.8 289.44 C 116.1 289.44 116.55 289.32 116.7 289.44 C 116.85 289.57 116.7 289.57 116.55 289.69 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 117.45 290.31 C 117.3 290.55 117.15 290.31 117 290.43 C 117 290.31 117.15 290.18 117.3 290.18 C 117.3 290.18 117.45 290.31 117.45 290.31 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 117.15 290.8 C 117 290.8 116.85 290.92 116.55 290.8 C 116.85 290.68 117.3 290.8 117.6 290.68 C 117.6 290.68 117.6 290.8 117.6 290.8 C 117.45 290.8 117.3 290.8 117.15 290.8 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 116.55 294.24 C 116.55 294.24 116.25 294.24 116.25 293.99 C 116.4 293.99 116.4 293.87 116.55 293.99 C 116.7 293.99 116.7 294.12 116.55 294.24 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 116.1 294.24 C 115.95 294.24 115.95 294.12 115.95 294.12 C 115.95 294.12 115.8 293.99 115.95 293.99 C 116.1 293.99 116.1 293.87 116.25 293.99 C 116.25 294.12 116.25 294.12 116.1 294.24 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115.65 294.12 C 115.5 294.12 115.5 294.12 115.35 293.99 C 115.35 293.99 115.35 293.87 115.5 293.87 C 115.65 293.87 115.8 293.87 115.65 293.99 C 115.65 294.12 115.65 294.12 115.65 294.12 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115.2 293.87 C 115.2 293.87 115.05 293.87 115.05 293.87 C 115.05 293.75 115.2 293.63 115.35 293.75 C 115.35 293.75 115.35 293.87 115.2 293.87 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 117.15 291.04 C 117 291.04 117 291.04 116.85 290.92 C 117 290.92 117.3 290.92 117.45 290.92 C 117.45 291.04 117.3 291.04 117.15 291.04 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.25 292.15 C 99.15 294.36 99.15 294.36 99.15 294.36 C 101.1 298.05 101.1 298.05 101.1 298.05 C 102 294.24 102 294.24 102 294.24 C 101.85 292.02 101.85 292.02 101.85 292.02 C 101.4 291.78 101.4 291.78 101.4 291.78 C 100.8 292.64 100.8 292.64 100.8 292.64 C 98.85 291.53 98.85 291.53 98.85 291.53 C 98.85 291.78 98.25 292.15 98.25 292.15 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100.65 292.76 L 100.95 292.89 L 101.1 292.64 L 101.25 293.01 L 100.95 293.26 L 101.4 296.7 L 101.1 298.17 L 100.2 296.58 L 100.65 293.26 L 100.35 293.01 L 100.65 292.76 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 114.75 293.99 C 115.05 294.73 115.05 294.73 115.05 294.73 C 117.3 298.29 117.3 298.29 117.3 298.29 C 118.05 294.98 118.05 294.98 118.05 294.98 C 117.6 293.87 117.6 293.87 117.6 293.87 C 116.55 294.85 114.75 293.99 114.75 293.99 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 112.65 318.7 C 111.9 319.44 111.9 319.44 111.9 319.44 C 111.15 319.68 111.15 319.68 111.15 319.68 C 110.25 319.93 110.25 319.44 110.25 319.44 C 110.85 318.33 110.85 318.33 110.85 318.33 C 110.55 318.7 110.25 319.07 109.95 319.44 C 109.65 319.8 109.35 320.17 109.35 320.54 C 109.35 320.54 109.65 320.67 109.8 320.67 C 110.25 320.54 110.85 320.54 111.3 320.3 C 111.75 320.17 112.05 319.68 112.35 319.44 C 112.5 319.56 112.35 319.8 112.5 319.93 C 112.65 319.56 112.65 319.07 112.8 318.7 Z",
    fill: "#036897",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(3, 104, 151), rgb(92, 179, 220))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.45 296.58 C 119.85 295.84 119.25 296.45 119.25 296.45 C 118.95 296.94 119.4 297.19 119.4 297.19 C 119.4 297.19 119.4 297.19 119.4 297.19 C 119.1 296.7 119.55 296.45 119.55 296.45 C 120 296.82 120.45 296.58 120.45 296.58 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.3 295.59 C 120.3 295.34 119.85 295.47 119.85 295.59 C 119.7 295.59 119.85 295.47 119.85 295.47 C 119.85 295.34 119.7 295.34 119.55 295.34 C 119.55 295.47 119.55 295.59 119.55 295.59 C 119.4 295.47 119.1 295.34 119.1 295.71 C 118.95 295.84 119.25 295.71 119.4 295.96 C 119.25 295.96 119.1 295.84 119.1 295.96 C 119.1 295.96 118.95 296.08 119.1 296.21 C 119.25 296.21 119.4 296.08 119.55 296.08 C 119.55 296.21 119.4 296.45 119.7 296.33 C 119.85 296.33 119.85 296.08 119.85 295.96 C 119.85 296.08 120 296.08 120.15 296.21 C 120.15 296.08 120.3 296.08 120.3 295.96 C 120.45 295.71 120.15 295.84 120 295.71 C 120.15 295.84 120.3 295.71 120.3 295.59 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 330,
      marginLeft: 108
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 8,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font30 || (_font30 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Human Query")))))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 338,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "8px",
    textAnchor: "middle"
  }, "Human Q...")))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-78"
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 14.75,
    width: 310,
    height: 29.25,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)scale(0.9999999999999999)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "101%",
    height: "101%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 308,
      height: 1,
      paddingTop: 29,
      marginLeft: 200
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 24
    }
  }, _font31 || (_font31 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Semi AI Native", /*#__PURE__*/React.createElement("br", null))), _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null))))))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 354,
    y: 33,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Semi AI Native...")))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiAiNativedrawio);
export default __webpack_public_path__ + "static/media/SemiAiNative.drawio.d88a09d4618044ebd510e4a6dd09fca4.svg";
export { ForwardRef as ReactComponent };